<template>
  <span :class="pillClass">
    <slot />
  </span>
</template>

<script lang="ts">
const PILLCOLORS = {
  red: 'pill--red',
  yellow: 'pill--yellow',
  green: 'pill--green',
  blue: 'pill--blue',
  brand: 'pill--brand',
  grey: 'pill--grey',
  black: 'pill--black',
};

export default {
  name: 'Pill',
  props: {
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    pillClass(): string {
      return `pill ${PILLCOLORS[this.color]}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.pill {
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.09px;
  padding: 0.25rem 0.75rem;
  text-align: center;

  &--red {
    background: theme('colors.critical.subdued'); // theme.critical.subdued
    color: theme('colors.critical.contrast');
  }

  &--yellow {
    background: theme('colors.warning.subdued');
    color: theme('colors.warning.contrast');
  }

  &--green {
    background: theme('colors.success.subdued');
    color: theme('colors.success.contrast');
  }

  &--blue {
    background: theme('colors.safety.subdued');
    color: theme('colors.safety.contrast');
  }

  &--brand {
    background: theme('colors.primary.subdued');
    color: theme('colors.primary.DEFAULT');
  }

  &--grey {
    background: theme('colors.grey.divider.subdued');
    color: theme('colors.grey.text.subdued');
  }

  &--black {
    color: theme('colors.grey.background.subdued');
    background: theme('colors.grey.header');
  }
}
</style>
